import gql from 'graphql-tag'
import {
  AccountUpdateUserInfoMutation,
  AccountUpdateUserInfoVariables,
  AccountUpdateUserPasswordMutation,
  AccountUpdateUserPasswordVariables,
  AccountSetUserPasswordMutation,
  AccountSetUserPasswordVariables
} from '../../types/AccountUserMutations'

export const ACCOUNT_TOGGLE_FEATURE = gql`
  mutation ToggleFeature ($id: UUID, $status: StatusAbEnums!) {
    toggleFeature(id: $id, status: $status) {
      code
      success
      message
      accountFeature {
        id
        accountId
        status
        name
        description
        updated
      }
    }
  }
`

export const ACCOUNT_UPDATE_USER_INFO = gql<
  AccountUpdateUserInfoMutation,
  AccountUpdateUserInfoVariables
>`
  mutation AccountUpdateUserInfoMutation ($id: UUID!, $input: UpdateUserInfoInput!) {
    updateUserInfo(id: $id, input: $input) {
      code
      success
      message
      user {
        id
        firstName
        lastName
      }
    }
  }
`

export const ACCOUNT_UPDATE_USER_PASSWORD = gql<
  AccountUpdateUserPasswordMutation,
  AccountUpdateUserPasswordVariables
>`
  mutation AccountUpdateUserPasswordMutation ($id: UUID!, $input: UpdateUserPasswordInput!) {
    updateUserPassword(id: $id, input: $input) {
      code
      success
      message
      type
    }
  }
`

export const ACCOUNT_SET_USER_PASSWORD = gql<
  AccountSetUserPasswordMutation,
  AccountSetUserPasswordVariables
>`
  mutation AccountSetUserPasswordMutation ($id: UUID!, $input: SetUserPasswordInput!) {
    setUserPassword(id: $id, input: $input) {
      code
      success
      message
      type
    }
  }
`
